'use strict';

require('./elements/checkbox');
require('./elements/datetimepicker');
require('./elements/hidden');
require('./elements/radio');
require('./elements/select');
require('./elements/submit');
require('./elements/text');
require('./elements/textarea');
require('./elements/password');
require('./elements/selectButton');
require('./elements/switch');
require('./elements/imageList');
require('./elements/social');
require('./elements/selectTag');
require('./elements/menu');
require('./elements/searchPageType');
require('./elements/map');
require('./elements/imageLink');
require('./elements/instagram');
require('./elements/color');
require('./elements/colorPanel');
require('./elements/textList');
require('./elements/themeColor');
require('./elements/upload');
require('./elements/height');
require('./elements/containerWidth');
require('./elements/crop');
require('./elements/newsletter');
require('./elements/textButton');
require('./elements/searchList');
require('./elements/rte');
require('./elements/font');
require('./elements/checkList');
require('./elements/url');

require('./config');

module.exports = require('./builder');
